import { render, staticRenderFns } from "./grade-info-doubleOld.vue?vue&type=template&id=e0410272&scoped=true&lang=pug"
import script from "./grade-info-doubleOld.vue?vue&type=script&lang=js"
export * from "./grade-info-doubleOld.vue?vue&type=script&lang=js"
import style0 from "./grade-info-doubleOld.vue?vue&type=style&index=0&id=e0410272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0410272",
  null
  
)

export default component.exports